import React, { useEffect, useState, useRef } from 'react'
import {
    awaitDelay,
    charactersRemainingGet, getError, getLanguageObj, getResponse, isUndNullEmpNew, isUndNullNew, LoadingSection, sendMessageCloseCurrentWindow, settings, validateTextIsHTML
} from '../../helpers/UtilsHelper';
import HtmlParser from 'react-html-parser';
import BotEmojis from './BotEmojis';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import useAuth from '../../auth/useAuth';
import Menu from '../main/Menu';
import { ResponseClass } from '../../classes/main/responseClass';
import { BotClass } from '../../classes/bot/botClass';
import { UserClass } from '../../classes/user/userClass';
import { GlobalFormats } from '../../classes/main/globalFormatClass';
import { BotService } from '../../services/bots/BotService';
import { UserService } from '../../services/users/UserService';

const $ = window.$;

const { app, dualListBox, firebase, icons, images, labels, mercadoLibre, messages, summerNote } = settings;
const { fields: dbFields, ordersBy: dbOrdersBy, operators: dbOperators } = firebase?.firestore;
const { urls } = app?.backend;

const currentMethod = 'BotEdit - function';

export default function BotEdit({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
} = {}) {
    //#region variables
    const { id } = useParams();
    const auth = useAuth();
    const inputOrder = {
        max: 3,
        min: 1,
    };
    let dataObj = {};
    const rowsLength = 7;
    const chkBoStatusId = 'chkBoStatus';

    const [process, setProcess] = useState({
        showLoading: false,
        save: false,
        back: false,
    });
    const [errors, setErrors] = useState({
        name: '',
        order: '',
        event: '',
        module: '',
        message: '',
    });
    const isMount = useRef(true);

    const [charactersRemaining, setCharactersRemaining] = useState('');
    const [botEmojisShowModal, setBotEmojisShowModal] = useState(false);
    const [textAreasShow, setTextAreasShow] = useState({ textAreaOne: false, textAreaTwo: false });

    //#region bot
    const [bot, setBot] = useState(BotClass?.getClass());
    const [events, setEvents] = useState([]);
    const textAreaAnswerId = 'textAreaAnswer';
    const [modules, setModules] = useState([]);
    const [moduleEvents, setModuleEvents] = useState([]);
    //#endregion bot

    //#region users
    // const [users, setUsers] = useState([]);
    //#endregion users
    //#endregion variables

    //#region methods
    //#region bot
    const getBot = async ({
        id = '',
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getBot';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let events_ = [];
            let modules_ = [];
            let bot_ = BotClass?.getClass();
            //#endregion variables

            //#region get data (bot)
            response = await BotService.getById({
                id: id,
                token: auth?.account?.tokenVzLaML?.token,
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) return response;
            //#endregion get data (bot)

            //#region set data
            bot_ = response?.result?.bot;
            modules_ = response?.result?.modules || [];
            setModules(modules_);
            events_ = response?.result?.events || [];
            setEvents(events_);
            setModuleEvents(events_.filter(({ moduleId }) => moduleId === bot_.moduleId));
            setBot(bot_);
            //#endregion set data
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const editBot = async ({
        e = {},
        subMethod = '',
    } = {}) => {
        const currentMethod = 'editBot';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            //#region variables
            let modules_ = [];
            let events_ = [];
            let bot_ = BotClass?.getClass();
            //#endregion variables

            //#region process previous
            response = setErrorDefault({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            response = await checkFormValue({ type: 1, subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion process previous

            setProcess(prev => ({ ...prev, showLoading: true, save: true }));

            //#region update data (bot)
            response = await BotService.update({
                id: bot.id,
                token: auth?.account?.tokenVzLaML?.token,
                data: bot,
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) return;

            bot_ = response?.result?.bot;
            modules_ = response?.result?.modules || [];
            setModules(modules_);
            events_ = response?.result?.events || [];
            setEvents(events_);
            setModuleEvents(events_.filter(({ moduleId }) => moduleId === bot_.moduleId));
            setBot(bot_);
            //#endregion update data (bot)

            response = getResponse({
                type: 0,
                msgText_: `${messages?.processCompletedSuccessfully?.[languageObj?.id]}.`,
                // urlGoTo: urls?.bots,
            });
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, save: false, showLoading: false }));

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }
    //#endregion bot

    //#region users
    const getUsersByAccountId = async ({
        e = {},
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getUsersByAccountId';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();
            //#region variables
            // let users_ = [UserClass?.getClass()];
            //#endregion variables

            //#region get data (users)
            dataObj = {
                conditionals: [
                    { field: dbFields?.userId, operator: dbOperators?.equal, value: auth?.account?.uid, },
                ],
                ordersBy: [
                    { field: dbFields?.userName, value: dbOrdersBy?.asc, },
                ]
            };
            response = await UserService.getUsers({
                token: auth?.account?.tokenVzLaML?.token,
                data: dataObj,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return response;

            // users_ = response?.result || [];
            // setUsers(usersLocal);
            //#endregion get data (users)
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }
    //#endregion users

    //#region others
    const processSummerNote = async ({
        e = {},
        type = 0,
        value = '',
        subMethod = '',
    }) => {
        const currentMethod = 'processSummerNote';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            //#endregion variables

            //#region process
            switch (type) {
                case -1:
                    $(`#${summerNote?.btnEvents?.destroy}`).trigger('click');
                    break;
                case 0:
                    $(`#${summerNote?.btnEvents?.reset}`).trigger('click');
                    break;
                case 1:
                    $(`#${summerNote?.btnEvents?.init}`).trigger('click');
                    break;
                case 2:
                    $(`#${summerNote?.btnEvents?.code}`).trigger('click');
                    break;
                case 3:
                    $(`#${summerNote?.btnEvents?.isEmpty}`).trigger('click');
                    break;
                case 4:
                    $(`#${mercadoLibre?.objects?.html?.bots?.messageHideId}`).val(value);
                    $(`#${summerNote?.btnEvents?.setCode}`).trigger('click');
                    break;
                default:
                    $(`#${summerNote?.btnEvents?.destroy}`).trigger('click');
                    break
            }
            if (!isUndNullEmpNew({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }
            //#endregion process
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const processDualListBox = async ({
        e = {},
        type = 0,
        value = '',
        selected = false,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'processDualListBox';
        let response = getResponse({ type: 0 });
        try {
            //#region process
            switch (type) {
                case -1:
                    $(`#${dualListBox?.btnEvents?.destroy}`).trigger('click');
                    break;
                case 0:
                    $(`#${dualListBox?.btnEvents?.refresh}`).trigger('click');
                    break;
                case 1: {
                    const dlbLabels = dualListBox?.labels;
                    const langId = languageObj?.id || 'es';
                    const customProps = {
                        nonSelectedListLabel: dlbLabels?.nonSelectedListLabel?.[langId] || 'No asignadas',
                        selectedListLabel: dlbLabels?.selectedListLabel?.[langId] || 'Asignadas',
                        filterPlaceHolder: dlbLabels?.filterPlaceHolder?.[langId] || 'Filtrar...',
                        filterTextClear: dlbLabels?.filterTextClear?.[langId] || 'Mostrar todos',
                        infoText: dlbLabels?.infoText?.[langId] || 'Mostrando todos ({0})',
                        infoTextFiltered: dlbLabels?.infoTextFiltered?.[langId] || '<span class="badge badge-warning">Filtrados</span> {0} de {1}',
                        infoTextEmpty: dlbLabels?.infoTextEmpty?.[langId] || 'Lista vacía',
                        moveSelectedLabel: dlbLabels?.moveSelectedLabel?.[langId] || 'Mover seleccionado',
                        moveAllLabel: dlbLabels?.moveAllLabel?.[langId] || 'Mover todos',
                        removeSelectedLabel: dlbLabels?.removeSelectedLabel?.[langId] || 'Quitar seleccionado',
                        removeAllLabel: dlbLabels?.removeAllLabel?.[langId] || 'Quitar todos',
                    };
                    $(`#${dualListBox?.btnEvents?.init}`).val(JSON.stringify(customProps));
                    $(`#${dualListBox?.btnEvents?.init}`).trigger('click');
                    $(`#${dualListBox?.btnEvents?.init}`).val('');
                    break;
                }
                case 2:
                    response.result = $(`#${mercadoLibre?.objects?.html?.bots?.duallistboxId}`).val();
                    break;
                case 3:
                    $(`#${dualListBox?.btnEvents?.setValue}`).val(`{"id": "${value}", "selected": ${selected}}`);
                    $(`#${dualListBox?.btnEvents?.setValue}`).trigger('click');
                    break;
                default:
                    $(`#${dualListBox?.btnEvents?.destroy}`).trigger('click');
                    break
            }

            e?.preventDefault?.();
            //#endregion process
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const checkFormValue = async ({
        type = 0,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'checkFormValue';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let responseOne = new ResponseClass()?.getClass();
            let responseTwo = new ResponseClass()?.getClass();
            //#endregion variables

            //#region methods
            //#region duallistbox (get value)
            responseOne = await processDualListBox({
                e: null,
                type: 2,
                value: '',
                selected: false,
                subMethod: currentMethod,
            });
            if (!responseOne.isSuccess || responseOne.isWarning) return responseOne;
            //#endregion duallistbox (get value)

            //#region set data (bot / accounts)
            responseOne.result = responseOne?.result || [];
            responseOne = await setFormData({
                e: null,
                type: 'accounts',
                value: responseOne?.result,
                subMethod: currentMethod
            });

            if (!responseOne.isSuccess || responseOne.isWarning) return responseOne;
            //#endregion set data (bot / accounts)

            //#region add / edit
            if (isUndNullEmpNew({ data: bot?.name, subMethod: currentMethod, })?.result) {
                setErrors(prev => ({ ...prev, name: messages?.thisFieldRequired?.[languageObj?.id] }));
                response = getResponse({ type: 1 });
            }

            if (isUndNullEmpNew({ data: bot?.moduleId, subMethod: currentMethod, })?.result) {
                setErrors(prev => ({ ...prev, module: messages?.thisFieldRequired?.[languageObj?.id] }));
                response = getResponse({ type: 1 });
            }

            if (isUndNullEmpNew({ data: bot?.eventId, subMethod: currentMethod, })?.result) {
                setErrors(prev => ({ ...prev, event: messages?.thisFieldRequired?.[languageObj?.id] }));
                response = getResponse({ type: 1 });
            }
            //#endregion add / edit

            //#region edit
            if (type === 1) {
                if (isUndNullNew({ data: bot?.order, subMethod: currentMethod, })?.result || bot?.order <= 0) {
                    setErrors(prev => ({ ...prev, order: messages?.thisFieldRequired?.[languageObj?.id] }));
                    response = getResponse({ type: 1 });
                }

                //#region post sales
                if (textAreasShow.textAreaOne && !textAreasShow.textAreaTwo) {
                    //#region set data from textArea
                    responseTwo = await processSummerNote({
                        e: null,
                        type: 2,
                        subMethod: currentMethod,
                    });

                    if (!responseTwo.isSuccess || responseTwo.isWarning) return responseTwo;
                    //#endregion set data from textArea

                    //#region check if data is empy from textArea
                    responseTwo = await processSummerNote({
                        e: null,
                        type: 3,
                        subMethod: currentMethod,
                    });

                    if (!responseTwo.isSuccess || responseTwo.isWarning) return responseTwo;
                    //#endregion check if data is empy from textArea

                    if ($(`#${summerNote?.btnEvents?.isEmpty}`).val() === 'true') {
                        setErrors(prev => ({ ...prev, message: messages?.thisFieldRequired?.[languageObj?.id] }));
                        response = getResponse({ type: 1 });
                    }

                    const messageHideInnerTextObj_ = $(`#${mercadoLibre?.objects?.html?.bots?.messageHideInnerTextId}`);
                    if (messageHideInnerTextObj_.val().length > mercadoLibre?.methods?.postSales?.seller?.maxLength) {
                        setErrors(prev => ({ ...prev, message: `${messages?.allowedCharacters?.[languageObj?.id]}: <b>${mercadoLibre?.methods?.postSales?.seller?.maxLength}</b>` }));
                        response = getResponse({ type: 1 });
                    }
                }
                //#endregion post sales

                //#region question / answers
                if (!textAreasShow.textAreaOne && textAreasShow.textAreaTwo) {
                    //#region set data from textArea
                    if (isUndNullEmpNew({ data: bot?.message, subMethod: currentMethod, })?.result) {
                        setErrors(prev => ({ ...prev, message: messages?.thisFieldRequired?.[languageObj?.id] }));
                        response = getResponse({ type: 1 });
                    } else if (bot?.message?.length > mercadoLibre?.methods?.questionsAnswers?.answers?.maxLength) {
                        setErrors(prev => ({ ...prev, message: `${messages?.allowedCharacters?.[languageObj?.id]}: <b>${mercadoLibre?.methods?.questionsAnswers?.answers?.maxLength}</b>` }));
                        response = getResponse({ type: 1 });
                    } else {
                        responseTwo = validateTextIsHTML({ text: bot.message, subMethod: currentMethod });
                        if (!responseTwo.isSuccess || responseTwo.isWarning) {
                            return responseTwo;
                        }
                        if (!mercadoLibre?.methods?.questionsAnswers?.answers?.htmlFormat && responseTwo.result) {
                            setErrors(prev => ({ ...prev, message: `${messages?.onlyPlainTextIsAllowed?.[languageObj?.id]}` }));
                            response = getResponse({ type: 1 });
                        }
                    }
                    //#endregion set data from textArea
                }
                //#endregion question / answers
            }
            //#endregion edit
            //#endregion methods
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const setFormData = async ({
        e = {},
        type = '',
        value = '',
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setFormData';
        let response = getResponse({ type: 0 });
        try {
            // const setFormData_ = {
            //     accounts: [],
            // };
            const setFormData_ = bot;
            //#region process
            switch (type) {
                case 'order':
                    setBot(prev => ({
                        ...prev,
                        [type]: isUndNullEmpNew({ data: value, subMethod: currentMethod, })?.result || isNaN(value) ? 1 : parseInt(value),
                    }));
                    break;
                case 'moduleId':
                    setModuleEvents(events.filter(({ moduleId }) => moduleId === value));
                    setBot(prev => ({ ...prev, [type]: value, eventId: '', message: '' }));
                    await setMessageType({ moduleId: value, eventId: '', subMethod: currentMethod });
                    break;
                case 'eventId':
                    setBot(prev => ({ ...prev, [type]: value, message: '' }));
                    await setMessageType({ moduleId: bot.moduleId, eventId: value, subMethod: currentMethod });
                    break;
                case 'message':
                    setBot(prev => ({ ...prev, [type]: value }));
                    if (textAreasShow.textAreaOne && !textAreasShow.textAreaTwo) {
                        //#region postSales
                        setCharactersRemaining(
                            charactersRemainingGet(
                                $(`#${mercadoLibre?.objects?.html?.bots?.messageHideInnerTextId}`).val(),
                                mercadoLibre?.methods?.postSales?.seller?.maxLength,
                                `${messages?.charactersRemaining?.[languageObj?.id]}:`,
                                'Message - PostSales - setFormData'
                            )?.result
                        );
                        //#endregion postSales
                    } else if (!textAreasShow.textAreaOne && textAreasShow.textAreaTwo) {
                        //#region QuestionsAnswers
                        setCharactersRemaining(
                            charactersRemainingGet(
                                value,
                                mercadoLibre?.methods?.questionsAnswers?.answers?.maxLength,
                                `${messages?.charactersRemaining?.[languageObj?.id]}:`,
                                'Message - setFormData'
                            )?.result
                        );
                        //#endregion QuestionsAnswers
                    }
                    break;
                case 'accounts':
                    setBot(prev => ({ ...prev, accounts: value }));
                    setFormData_.accounts = value;
                    break;
                default:
                    setBot(prev => ({ ...prev, [type]: value, accounts: value }));
                    break;
            }

            if (type === 'moduleId' || type === 'eventId') {
                await processSummerNote({ e: null, type: 0, value: '', subMethod: currentMethod });
                $(`#${textAreaAnswerId}`).val('');
                $(`#${mercadoLibre?.objects?.html?.bots?.messageHideId}`).val('');
                $(`#${mercadoLibre?.objects?.html?.bots?.messageHideId}`).trigger('click');
            }
            //#endregion process

            response.result = setFormData_;
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const setErrorDefault = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setErrorDefault';
        let response = getResponse({ type: 0 });
        try {
            setErrors({
                name: '',
                order: '',
                event: '',
                module: '',
                message: '',
            });
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const getData = async ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            let bot_ = BotClass?.getClass();
            let users_ = [UserClass?.getClass()];
            let responseOne = new ResponseClass()?.getClass();

            setProcess(prev => ({ ...prev, showLoading: true }));

            //#region methods
            //#region get data (bot)
            response = await getBot({
                id: id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;

            bot_ = response?.result?.bot || {};
            //#endregion get data (bot)

            //#region get data (users)
            response = await getUsersByAccountId({
                e: null,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;

            users_ = response?.result || {};
            //#endregion get data (users)

            //#region summerNote
            //#region message
            //#region initialize summerNote
            response = await processSummerNote({
                e: null,
                type: 1,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion initialize summerNote

            //#region set data summerNote
            if (!isUndNullEmpNew({ data: bot_?.message, subMethod: currentMethod, })?.result) {
                response = await processSummerNote({
                    e: null,
                    type: 4,
                    value: bot_.message,
                    subMethod: currentMethod,
                });
                if (!response?.isSuccess || response?.isWarning) return;
            }
            //#endregion set data summerNote

            //#region textares show / hide
            response = await setMessageType({
                moduleId: bot_.moduleId,
                eventId: bot_.eventId,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion textares show / hide

            //#region set text remaining
            if (!isUndNullEmpNew({ data: bot_?.moduleId, subMethod: currentMethod, })?.result &&
                !isUndNullEmpNew({ data: bot_?.eventId, subMethod: currentMethod, })?.result) {
                if (bot_.moduleId === mercadoLibre?.process?.modules?.[0]?.id) {
                    if (bot_.eventId === mercadoLibre?.process?.events?.[0]?.id ||
                        bot_.eventId === mercadoLibre?.process?.events?.[1]?.id) {
                        //#region QuestionAnswers
                        setCharactersRemaining(
                            charactersRemainingGet(
                                bot_.message,
                                mercadoLibre?.methods?.questionsAnswers?.answers?.maxLength,
                                `${messages?.charactersRemaining?.[languageObj?.id]}:`,
                                'getBot - getData'
                            )?.result
                        );
                        //#endregion QuestionAnswers
                    }
                } else if (bot_.moduleId === mercadoLibre?.process?.modules[1].id) {
                    if (bot_.eventId === mercadoLibre?.process?.events[2].id) {
                        //#region postSales
                        setCharactersRemaining(
                            charactersRemainingGet(
                                $(`#${mercadoLibre?.objects?.html?.bots?.messageHideInnerTextId}`).val(),
                                mercadoLibre?.methods?.postSales?.seller?.maxLength,
                                `${messages?.charactersRemaining?.[languageObj?.id]}:`,
                                'getBot - getData'
                            )?.result
                        );
                        //#endregion postSales
                    }
                }
            }
            //#endregion set text remaining
            //#endregion message
            //#endregion summerNote

            //#region dualistBox
            //#region initialize
            response = await processDualListBox({
                e: null,
                type: 1,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion initialize

            //#region add data
            if (!isUndNullEmpNew({ data: bot_?.accounts, subMethod: currentMethod, })?.result && bot_?.accounts?.length > 0) {
                //#region selected 
                let selectedListLocal = users_.filter((detail) => bot_.accounts.includes(detail.userName));
                for (const detail of selectedListLocal) {
                    responseOne = await processDualListBox({
                        e: null,
                        type: 3,
                        value: detail.userName,
                        selected: true,
                        subMethod: currentMethod,
                    });

                    if (!responseOne?.isSuccess || responseOne?.isWarning) return;
                }
                //#endregion selected 

                //#region no selected 
                let noSelectedListLocal = users_.filter((detail) => !bot_.accounts.includes(detail.userName));
                for (const detail of noSelectedListLocal) {
                    responseOne = await processDualListBox({
                        e: null,
                        type: 3,
                        value: detail?.userName,
                        selected: false,
                        subMethod: currentMethod
                    });

                    if (!responseOne?.isSuccess || responseOne?.isWarning) return;
                }
                //#endregion no selected 
            } else if (!isUndNullNew({ data: users_, subMethod: currentMethod, })?.result && users_?.length > 0) {
                //#region no selected
                for (const detail of users_) {
                    responseOne = await processDualListBox({
                        e: null,
                        type: 3,
                        value: detail?.userName,
                        selected: false,
                        subMethod: currentMethod,
                    });

                    if (!responseOne?.isSuccess || responseOne?.isWarning) return;
                }
                //#endregion no selected
            }
            //#endregion add data
            //#endregion dualistBox
            //#endregion methods
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: '' });
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false }));

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const setMessageType = async ({
        moduleId = '',
        eventId = '',
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setMessageType';
        let response = getResponse({ type: 0 });
        try {
            //#region process
            if (!isUndNullEmpNew({ data: moduleId, subMethod: currentMethod, })?.result &&
                !isUndNullEmpNew({ data: eventId, subMethod: currentMethod, })?.result) {
                if (moduleId === mercadoLibre?.process?.modules?.[0]?.id) {
                    if (eventId === mercadoLibre?.process?.events?.[0]?.id ||
                        eventId === mercadoLibre?.process?.events?.[1]?.id) {
                        setTextAreasShow({ textAreaOne: false, textAreaTwo: true });
                    }
                } else if (moduleId === mercadoLibre?.process?.modules[1].id) {
                    if (eventId === mercadoLibre?.process?.events?.[2]?.id) {
                        setTextAreasShow({ textAreaOne: true, textAreaTwo: false });
                    }
                }
            }
            //#endregion process
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const showEmojis = async ({
        e = {},
        subMethod = '',
    } = {}) => {
        const currentMethod = 'showEmojis';
        let response = getResponse({ type: 0 });
        try {
            //#region process
            setBotEmojisShowModal(true);
            // window.$(`#${botEmojisModalId}`).modal('show');
            //#endregion process
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const goToBack = async ({
        e = {},
        subMethod = '',
    } = {}) => {
        const currentMethod = 'goToBack';
        let response = getResponse({ type: 0 });
        try {
            //#region process
            setProcess(prev => ({ ...prev, showLoading: true, back: true }));
            await awaitDelay({ delayTime: settings?.timers?.oneSeconds });
            window.location.href = urls?.bots;
            //#endregion process
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, back: false, showLoading: false }));

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'onViewLoad' });
        return () => { isMount.current = false; };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion others
    //#endregion methods

    return (
        <div>
            <Menu viewName='bots' process='bots' processLevel1='' />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Page header) - 2026 Premium floating bar */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>{labels?.bots?.[languageObj?.id]}</h4>
                            </div>{/* /.col */}
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href={urls?.home}>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item'><a href='/bots'>{labels?.bots?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{labels?.edit?.[languageObj?.id]}</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>
                        <div className='row'>
                            <div className='col-12'>
                                <form onSubmit={(e) => editBot({ e: e, subMethod: 'form-onSubmit' })}>
                                    <div className={settings?.html?.cards?.default} style={{ borderRadius: '8px' }}>
                                        <LoadingSection alt='loadingSection'
                                            className='overlay dark text-white'
                                            height={20}
                                            hidden={!process?.showLoading}
                                            width={20}
                                            languageId={languageObj?.id}
                                            subMethod={currentMethod} />

                                        <div className='card-header bg-white border-0 pt-4 px-4'>
                                            <div className='d-flex align-items-center justify-content-between'>
                                                <div className='d-flex align-items-center'>
                                                    <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                        style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <img alt={labels?.bots?.[languageObj?.id]}
                                                            style={{ width: '25px', height: '25px', objectFit: 'contain' }}
                                                            src={settings?.images?.icons?.bot || images?.icons?.bot} />
                                                    </div>
                                                    <div className='d-flex flex-column'>
                                                        <h5 className='mb-0 font-weight-bold text-dark'>{labels?.bots?.[languageObj?.id]}</h5>
                                                    </div>
                                                </div>
                                                <div className='card-tools'>
                                                    <button type='button'
                                                        className='btn btn-tool'
                                                        data-card-widget='collapse'>
                                                        <i className={icons?.fasFa?.minus} />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <div className='card-body px-4 pb-0'>

                                            {/* Name Input */}
                                            <div className='row'>
                                                <div className='col-12 mb-3'>
                                                    <div className='form-group'>
                                                        <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                                                            {labels?.name?.[languageObj?.id]}
                                                        </label>
                                                        <div className='position-relative'>
                                                            <i className={`${icons?.fasFa?.spellCheck} position-absolute input-icon-left`} />
                                                            <input className='form-control border-0 shadow-sm form-input-icon'
                                                                title={labels?.name?.[languageObj?.id]}
                                                                type='text'
                                                                onChange={(e) => setFormData({ type: 'name', value: e.target.value, subMethod: 'inputName' })}
                                                                onFocus={() => setErrors(prev => ({ ...prev, name: '' }))}
                                                                placeholder={labels?.name?.[languageObj?.id]}
                                                                value={bot?.name || ''} />
                                                        </div>
                                                        <div className='form-text mt-1 form-error-text'>{HtmlParser(errors?.name)}</div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Module & Event Selects */}
                                            <div className='row'>
                                                <div className='col-12 col-md-6 mb-3'>
                                                    <div className='form-group'>
                                                        <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                                                            {labels?.module?.[languageObj?.id]}
                                                        </label>
                                                        <div className='position-relative'>
                                                            <i className={`${icons?.fasFa?.listUl} position-absolute input-icon-left`} />
                                                            <select className='form-control border-0 shadow-sm form-input-icon custom-select-premium'
                                                                value={bot?.moduleId || ''}
                                                                onChange={(e) => setFormData({ type: 'moduleId', value: e.target.value, subMethod: 'selectModules' })}
                                                                onFocus={() => setErrors(prev => ({ ...prev, module: '' }))}
                                                                placeholder={labels?.module?.[languageObj?.id]}
                                                                title={labels?.module?.[languageObj?.id]}>
                                                                <option key='nothing' value=''>{messages?.selectMethod?.[languageObj?.id]}</option>
                                                                {modules.map((detail) => <option key={detail.id} value={detail.id}>{detail.name?.[languageObj?.id]}</option>)}
                                                            </select>
                                                        </div>
                                                        <div className='form-text mt-1 form-error-text'>{HtmlParser(errors?.module)}</div>
                                                    </div>
                                                </div>

                                                <div className='col-12 col-md-6 mb-3'>
                                                    <div className='form-group'>
                                                        <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                                                            {labels?.event?.[languageObj?.id]}
                                                        </label>
                                                        <div className='position-relative'>
                                                            <i className={`${icons?.fasFa?.listOl} position-absolute input-icon-left`} />
                                                            <select className='form-control border-0 shadow-sm form-input-icon custom-select-premium'
                                                                value={bot?.eventId || ''}
                                                                onChange={(e) => setFormData({ type: 'eventId', value: e.target.value, subMethod: 'selectEvents' })}
                                                                onFocus={() => setErrors(prev => ({ ...prev, event: '' }))}
                                                                placeholder={labels?.event?.[languageObj?.id]}
                                                                title={labels?.event?.[languageObj?.id]}>
                                                                <option key='nothing' value=''>{messages?.selectEvent?.[languageObj?.id]}</option>
                                                                {moduleEvents.map((detail) => <option key={detail.id} value={detail.id}>{detail.name?.[languageObj?.id]}</option>)}
                                                            </select>
                                                        </div>
                                                        <div className='form-text mt-1 form-error-text'>{HtmlParser(errors?.event)}</div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Status & Order */}
                                            <div className='row align-items-center'>
                                                <div className='col-12 col-md-6 mb-3'>
                                                    <div className='form-group mb-0'>
                                                        <div className='icheck-primary d-inline'>
                                                            <input type='checkbox'
                                                                id={chkBoStatusId}
                                                                checked={bot?.status || false}
                                                                onChange={(e) => setFormData({ type: 'status', value: e.target.checked, subMethod: 'chkStatus' })} />
                                                            <label htmlFor={chkBoStatusId} style={{ cursor: 'pointer' }}>
                                                                {labels?.enabled?.[languageObj?.id]}?
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='col-12 col-md-6 mb-3'>
                                                    <div className='form-group mb-0'>
                                                        <label className='small font-weight-bold text-uppercase form-label-uppercase mb-2'>
                                                            {labels?.order?.[languageObj?.id]}
                                                        </label>
                                                        <div className='position-relative'>
                                                            <i className={`${icons?.fasFa?.sortNumericUpAlt} position-absolute input-icon-left`} />
                                                            <input className='form-control border-0 shadow-sm form-input-icon'
                                                                max={inputOrder.max}
                                                                min={inputOrder.min}
                                                                title={labels?.order?.[languageObj?.id]}
                                                                type='number'
                                                                onChange={(e) => setFormData({ type: 'order', value: e.target.value, subMethod: 'inputOrder' })}
                                                                onFocus={() => setErrors(prev => ({ ...prev, order: '' }))}
                                                                placeholder={labels?.order?.[languageObj?.id]}
                                                                value={bot?.order} />
                                                        </div>
                                                        <div className='form-text mt-1 form-error-text'>{HtmlParser(errors?.order)}</div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Message Section Header */}
                                            <div className='row mt-4 mb-2'>
                                                <div className='col-12 col-md-3'><h6 className='font-weight-bold text-dark'>{labels?.message?.[languageObj?.id]}</h6></div>
                                                <div className='col-12 col-md-9'><hr className='my-2' /></div>
                                            </div>

                                            {/* PostSales Textarea Flow */}
                                            <div hidden={!textAreasShow.textAreaOne && textAreasShow.textAreaTwo}>
                                                <div className='form-group text-right mb-2'>
                                                    <button className='btn btn-light border shadow-sm font-weight-bold text-secondary btn-sm'
                                                        onClick={(e) => showEmojis({ e, subMethod: 'btnEmojisShow' })}
                                                        data-title={labels?.emoji?.[languageObj?.id]}
                                                        type='button'>
                                                        <i className={icons?.fasFa?.grin} />
                                                    </button>
                                                </div>
                                                <div className='form-group'>
                                                    <div className='position-relative'>
                                                        <i className={`${icons?.fasFa?.edit} position-absolute input-icon-left`} style={{ top: '25px', transform: 'none' }} />
                                                        <textarea id={mercadoLibre?.objects?.html?.bots?.messageId}
                                                            hidden={!textAreasShow.textAreaOne}
                                                            // className='form-control border-0 shadow-sm form-textarea-premium'
                                                            className='form-control border-0 shadow-sm form-input-icon'
                                                            style={{ height: 'auto', paddingTop: '15px' }}
                                                            maxLength={mercadoLibre?.methods?.postSales?.seller?.maxLength}
                                                            onClick={() => setErrors(prev => ({ ...prev, message: '' }))}
                                                            placeholder={labels?.message?.[languageObj?.id]} />
                                                    </div>
                                                    <div className='form-text text-muted small mt-1'>{HtmlParser(charactersRemaining)}</div>
                                                    <div className='form-text mt-1 form-error-text'>{HtmlParser(errors?.message)}</div>
                                                </div>
                                                <div className='text-muted small' style={{ fontSize: '13px' }}>
                                                    <dl className='row'>
                                                        <dt className='col-md-4'>[greeting]</dt>
                                                        <dd className='col-md-8'>{messages?.displaysTheGreetingAccordingToTheTime?.[languageObj?.id]}.</dd>
                                                        <dt className='col-md-4'>\t</dt>
                                                        <dd className='col-md-8'>{labels?.tab?.[languageObj?.id]}.</dd>
                                                        <dt className='col-md-4'>\n</dt>
                                                        <dd className='col-md-8'>{labels?.lineReturn?.[languageObj?.id]}.</dd>
                                                        <dt className='col-md-4'>{mercadoLibre?.methods?.postSales?.seller?.item?.title}</dt>
                                                        <dd className='col-md-8'>{labels?.item?.[languageObj?.id]}.</dd>
                                                        <dt className='col-md-4'>{mercadoLibre?.methods?.postSales?.seller?.item?.quantity}</dt>
                                                        <dd className='col-md-8'>{labels?.quantity?.[languageObj?.id]}.</dd>
                                                        <dt className='col-md-4'>{mercadoLibre?.methods?.postSales?.seller?.item?.price}</dt>
                                                        <dd className='col-md-8'>{labels?.price?.[languageObj?.id]}.</dd>
                                                        <dt className='col-md-4'>{mercadoLibre?.methods?.postSales?.seller?.item?.priceOC}</dt>
                                                        <dd className='col-md-8'>{labels?.priceOtherCurrency?.[languageObj?.id]}.</dd>
                                                        <dt className='col-md-4'>{mercadoLibre?.methods?.postSales?.seller?.order?.number}</dt>
                                                        <dd className='col-md-8'>{labels?.order?.[languageObj?.id]}.</dd>
                                                        <dt className='col-md-4'>{mercadoLibre?.methods?.postSales?.seller?.order?.dateTime}</dt>
                                                        <dd className='col-md-8'>{labels?.dateTime?.[languageObj?.id]}.</dd>
                                                        <dt className='col-md-4'>{mercadoLibre?.methods?.postSales?.seller?.order?.date}</dt>
                                                        <dd className='col-md-8'>{labels?.date?.[languageObj?.id]}.</dd>
                                                        <dt className='col-md-4'>{mercadoLibre?.methods?.postSales?.seller?.order?.time}</dt>
                                                        <dd className='col-md-8'>{labels?.time?.[languageObj?.id]}.</dd>
                                                        <dt className='col-md-4'>{mercadoLibre?.methods?.postSales?.seller?.buyer?.fullName}</dt>
                                                        <dd className='col-md-8'>{labels?.fullName?.[languageObj?.id]}.</dd>
                                                        <dt className='col-md-4'>{mercadoLibre?.methods?.postSales?.seller?.buyer?.nickName}</dt>
                                                        <dd className='col-md-8'>{labels?.name?.[languageObj?.id]}.</dd>
                                                    </dl>
                                                </div>
                                                <div className='form-group'>
                                                    <textarea id={mercadoLibre?.objects?.html?.bots?.messageHideId}
                                                        // className='form-control'
                                                        className='form-control border-0 shadow-sm form-input-icon'
                                                        hidden={true}
                                                        maxLength={mercadoLibre?.methods?.postSales?.seller?.maxLength}
                                                        title={labels?.message?.[languageObj?.id]}
                                                        onClick={(e) => setFormData({ e: e, type: 'message', value: e.target.value, subMethod: 'textAreaMessage' })}
                                                        onFocus={() => setErrors(prev => ({ ...prev, message: '' }))}
                                                        placeholder={labels?.message?.[languageObj?.id]}
                                                        rows={rowsLength} />
                                                </div>
                                                <div className='form-group'>
                                                    <textarea id={mercadoLibre?.objects?.html?.bots?.messageHideInnerTextId}
                                                        // className='form-control'
                                                        className='form-control border-0 shadow-sm form-input-icon'
                                                        hidden={true}
                                                        maxLength={mercadoLibre?.methods?.postSales?.seller?.maxLength}
                                                        title={labels?.message?.[languageObj?.id]}
                                                        placeholder={labels?.message?.[languageObj?.id]}
                                                        rows={rowsLength} />
                                                </div>
                                            </div>

                                            {/* QuestionsAnswers Textarea Flow */}
                                            <div hidden={textAreasShow.textAreaOne && !textAreasShow.textAreaTwo}>
                                                <div className='form-group'>
                                                    <div className='position-relative'>
                                                        <i className={`${icons?.fasFa?.edit} position-absolute input-icon-left`} style={{ top: '25px', transform: 'none' }} />
                                                        <textarea id={textAreaAnswerId}
                                                            // className='form-control border-0 shadow-sm form-textarea-premium'
                                                            className='form-control border-0 shadow-sm form-input-icon'
                                                            style={{ height: 'auto', paddingTop: '15px' }}
                                                            hidden={!textAreasShow.textAreaTwo}
                                                            maxLength={mercadoLibre?.methods?.questionsAnswers?.answers?.maxLength}
                                                            title={labels?.message?.[languageObj?.id]}
                                                            onChange={(e) => setFormData({ e: e, type: 'message', value: e.target.value, subMethod: 'textAreaMessage' })}
                                                            onFocus={() => setErrors(prev => ({ ...prev, message: '' }))}
                                                            placeholder={labels?.message?.[languageObj?.id]}
                                                            rows={rowsLength}
                                                            value={bot?.message || ''} />
                                                    </div>
                                                    <div className='form-text text-muted small mt-1'>{HtmlParser(charactersRemaining)}</div>
                                                    <div className='form-text mt-1 form-error-text'>{HtmlParser(errors?.message)}</div>
                                                    <div className='text-muted small mt-2' style={{ fontSize: '13px' }}>
                                                        <dl className='row'>
                                                            <dt className='col-md-4'>[greeting]</dt>
                                                            <dd className='col-md-8'>{messages?.displaysTheGreetingAccordingToTheTime?.[languageObj?.id]}.</dd>
                                                            <dt className='col-md-4'>[buyerName]</dt>
                                                            <dd className='col-md-8'>{messages?.displaysTheBuyerName?.[languageObj?.id]}.</dd>
                                                        </dl>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Accounts Section Header */}
                                            <div className='row mt-4 mb-2'>
                                                <div className='col-12 col-md-3'><h6 className='font-weight-bold text-dark'>{labels?.accounts?.[languageObj?.id]}</h6></div>
                                                <div className='col-12 col-md-9'><hr className='my-2' /></div>
                                            </div>

                                            {/* Dual Listbox Select */}
                                            <div className='form-group mb-4'>
                                                <select id={mercadoLibre?.objects?.html?.bots?.duallistboxId}
                                                    className='duallistbox' multiple='multiple'>
                                                </select>
                                            </div>

                                            {/* Summernote hidden triggers */}
                                            <div className='form-group' hidden={true}>
                                                <button className='btn btn-sm btn-outline-primary' id={summerNote?.btnEvents?.setCode} title='set data' type='button'><i className={icons?.fasFa?.edit}></i></button>
                                                <button className='btn btn-sm btn-outline-secondary mx-1' id={summerNote?.btnEvents?.isEmpty} title='is empty?' type='button'><i className={icons?.farFa?.squareMinus}></i></button>
                                                <button className='btn btn-sm btn-outline-success' id={summerNote?.btnEvents?.code} title='get data' type='button'><i className={icons?.faFa?.check}></i></button>
                                                <button className='btn btn-sm btn-outline-info mx-1' id={summerNote?.btnEvents?.reset} title='clear' type='button'><i className={icons?.farFa?.file}></i></button>
                                                <button className='btn btn-sm btn-outline-info' id={summerNote?.btnEvents?.init} title='initialize' type='button'><i className={icons?.fasFa?.eye}></i></button>
                                                <button className='btn btn-sm btn-outline-warning mx-1' id={summerNote?.btnEvents?.destroy} title='destroy' type='button'><i className={icons?.fasFa?.eyeSlash}></i></button>
                                            </div>

                                            {/* Duallistbox hidden triggers */}
                                            <div className='form-group' hidden={true}>
                                                <button className='btn btn-sm btn-outline-success mx-1' id={dualListBox?.btnEvents?.setValue} title='set data' type='button'><i className={icons?.fasFa?.plusCircle}></i></button>
                                                <button className='btn btn-sm btn-outline-primary' id={dualListBox?.btnEvents?.refresh} title='refresh' type='button'><i className={icons?.fasFa?.edit}></i></button>
                                                <button className='btn btn-sm btn-outline-info mx-1' id={dualListBox?.btnEvents?.init} title='initialize' type='button'><i className={icons?.fasFa?.eye}></i></button>
                                                <button className='btn btn-sm btn-outline-warning' id={dualListBox?.btnEvents?.destroy} title='destroy' type='button'><i className={icons?.fasFa?.eyeSlash}></i></button>
                                            </div>
                                        </div>

                                        {/* Card Footer - 2026 Premium Actions bar */}
                                        <div className='card-footer border-0 bg-white px-4 pb-4 d-flex flex-wrap justify-content-end align-items-center' style={{ gap: '8px' }}>
                                            <button className='btn btn-primary shadow-sm font-weight-bold px-4'
                                                disabled={process?.showLoading}
                                                data-title={labels?.save?.[languageObj?.id]}
                                                type='submit'>
                                                {!process?.save ? (
                                                    <i className={`${icons?.fasFa?.save} mr-2`} />
                                                ) : (
                                                    <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                )} {labels?.save?.[languageObj?.id]}
                                            </button>
                                            {/* <a className='btn btn-light border shadow-sm font-weight-bold mx-1 px-4 text-secondary btn-general'
                                                href={urls?.bots}
                                                data-title={labels?.back?.[languageObj?.id]}>
                                                <i className={`${icons?.fasFa?.arrowAltCircleLeft} mr-2`} /> {labels?.back?.[languageObj?.id]}
                                            </a> */}
                                            <button className='btn btn-light border shadow-sm font-weight-bold mx-1 px-4 text-secondary btn-general'
                                                disabled={process?.showLoading}
                                                data-title={labels?.back?.[languageObj?.id]}
                                                onClick={(e) => { goToBack({ e: e, subMethod: 'btnGoToBack' }) }}
                                                type='button'>
                                                {!process?.back ? (
                                                    <i className={`${icons?.fasFa?.arrowAltCircleLeft} mr-2`} />
                                                ) : (
                                                    <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                )} {labels?.back?.[languageObj?.id]}
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>{/* /.container-fluid */}

                    {botEmojisShowModal && (
                        <BotEmojis processValues={{
                            showModal: botEmojisShowModal,
                            setShowModal: setBotEmojisShowModal,
                        }}
                            languageObj={languageObj} />
                    )}
                </section> {/* /.content */}
            </div>
        </div>
    )
}